<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>SARATHI 01 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>DL Number(GJ04 20120005008)</label>
          <b-form-input :formatter="capitalizeAll" id="dlnumber" name="dlnumber"
            v-model="dlnumber"></b-form-input></b-col>
        <b-col md="3">
          <label>DOB (1987-05-26)</label>
          <b-form-input :formatter="capitalizeAll" id="dob" name="dob" type="date" v-model="dob"></b-form-input></b-col>
        <b-col md="3">
          <b-button v-if="dob && dlnumber" @click="getAllSARATHI01Func()" size="sm" variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px">Fetch</b-button>
          <b-button @click="getAllSARATHISync()" size="sm" variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px">Sync</b-button>
        </b-col>
      </b-row>
      <hr />
      <div v-if="
        getAllSARATHI01.length <= 0 || getAllSARATHI01[0].response.dldetobj <= 0 || getAllSARATHI01[0].response.dldetobj[0].erormsg == 'Details not available'
      ">
        <b class="text-danger">{{ "No data found." }}</b>
      </div>
      <div v-else>
        <b-row>
          <b-col md="12" class="mt-1 mb-1">
            <strong>Response Status:</strong> {{ getAllSARATHI01[0].responseStatus }}
          </b-col>
        </b-row>

        <div v-for="dlDetail in getAllSARATHI01[0].response.dldetobj" :key="dlDetail.dlobj.dlLicno">
          <b-row class="border p-2 mb-2">
            <b-col md="12" class="mb-2">
              <h3>Driver License Details</h3>
            </b-col>

            <b-col md="4" class="mt-1 mb-1">
              <strong>License Number:</strong> {{ dlDetail.dlobj.dlLicno }}
            </b-col>
            <b-col md="4" class="mt-1 mb-1">
              <strong>Status:</strong> {{ dlDetail.dlobj.dlStatus }}
            </b-col>
            <b-col md="4" class="mt-1 mb-1">
              <strong>Issue Date:</strong> {{ dlDetail.dlobj.dlIssuedt }}
            </b-col>
            <b-col md="4" class="mt-1 mb-1">
              <strong>Office:</strong> {{ dlDetail.dlobj.olaName }}
            </b-col>
          </b-row>

          <div v-if="dlDetail.transReqObj && dlDetail.transReqObj.length">
            <h4>Transaction Requests</h4>
            <b-row class="border p-2 mb-2" v-for="transReq in dlDetail.transReqObj" :key="transReq.trEntrydt">
              <b-col md="4" class="mt-1 mb-1">
                <strong>Transaction Name:</strong> {{ transReq.trName }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Entry Date:</strong> {{ transReq.trEntrydt }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Office Name:</strong> {{ transReq.olaOffName }}
              </b-col>
            </b-row>
          </div>

          <div v-if="dlDetail.dlcovs && dlDetail.dlcovs.length">
            <h4>DL Covers</h4>
            <b-row class="border p-2 mb-2" v-for="cov in dlDetail.dlcovs" :key="cov.dcEndorsedt">
              <b-col md="4" class="mt-1 mb-1">
                <strong>Cover Abbreviation:</strong> {{ cov.covabbrv }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Issue Date:</strong> {{ cov.dcIssuedt }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Cover Description:</strong> {{ cov.covdesc }}
              </b-col>
            </b-row>
          </div>

          <div v-if="dlDetail.psvBadgeissued && dlDetail.psvBadgeissued.length">
            <h4>PSV Badges Issued</h4>
            <b-row class="border p-2 mb-2" v-for="badge in dlDetail.psvBadgeissued" :key="badge.pbiBadgeno">
              <b-col md="4" class="mt-1 mb-1">
                <strong>Badge Number:</strong> {{ badge.pbiBadgeno }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Issue Date:</strong> {{ badge.pbiIssdt }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Authority:</strong> {{ badge.pbiIssauth }}
              </b-col>
            </b-row>
          </div>

          <div v-if="dlDetail.bioObj">
            <h4>Biographical Information</h4>
            <b-row class="border p-2 mb-2">
              <b-col md="4" class="mt-1 mb-1">
                <strong>Full Name:</strong> {{ dlDetail.bioObj.bioFullName }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Date of Birth:</strong> {{ dlDetail.bioObj.bioDob }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Gender:</strong> {{ dlDetail.bioObj.bioGenderDesc }}
              </b-col>
              <b-col md="4" class="mt-1 mb-1">
                <strong>Blood Group:</strong> {{ dlDetail.bioObj.bioBloodGroupname }}
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllSARATHI01Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      dlnumber: "",
      dob: "",
      getAllSARATHI01: [],
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() { },

  beforeDestroy() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    getAllSARATHISync() {
      let payload = {};
      this.isLoading = true;
      this.getAllSARATHI01 = [];
      payload = {
        itemCode: "SyncSARATHI01",
        funcUrl: "SARATHI/01",
      };
      payload = JSON.stringify(payload);
      UlipService.getAllUlipList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("getAllSARATHISync Response: ", data);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("Catch on getAllSARATHI01 Error: ", error);
        });
    },
    async getAllSARATHI01Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllSARATHI01 = [];

      if (this.dlnumber && this.dob) {
        payload = {
          itemCode: "SARATHI01",
          funcUrl: "SARATHI/01",
          dlnumber: this.dlnumber,
          dob: this.dob,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (
                data.getAllSARATHI01 &&
                data.getAllSARATHI01.response &&
                data.getAllSARATHI01.response.response &&
                data.getAllSARATHI01.response.response.length > 0
              ) {
                this.getAllSARATHI01 = data.getAllSARATHI01.response.response;
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllSARATHI01 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// SARATHI_ResponseDisplay.vue?03faa680